import { Component } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-view-log-entries',
  templateUrl: './new-view-log-entries.component.html',
  styleUrls: ['./new-view-log-entries.component.css'],
})
export class NewViewLogEntriesComponent {
  modalLabel: any;
  logEntryData: any;
  logEntrychanges: any;
  constructor(private modal: CustomModalService) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.logEntryData = this.modal?.modalService?.config?.initialState?.['newViewLogEntriesData'];
    this.logEntrychanges = this.logEntryData.changes;
  }
  onClose() {
    this.modal.close();
  }
}
